<template>
  <helpPage></helpPage>
</template>

<script>
import helpPage from "./helpPage";
export default {
  name: "ParamSetting",
  components: { helpPage },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>
